import { grey } from 'globals/colors';
import { CSSProperties } from 'react';

export const getCircularProgressStyle = (): CSSProperties => ({
  color: grey.V4,
});

export default {
  getCircularProgressStyle,
};
